/**
 * Standardized error message extraction utility
 * Handles different error response structures from backend
 */
export function extractErrorMessage(error: any, fallbackMessage = 'An error occurred'): string {
  // Handle ApiError from openapi-typescript-codegen
  if (error.body && error.body.message) {
    // Backend validation errors come in body.message
    return Array.isArray(error.body.message) ? error.body.message.join(', ') : error.body.message;
  }

  // Handle HttpErrorResponse structure
  if (error.error && error.error.message) {
    return Array.isArray(error.error.message) ? error.error.message.join(', ') : error.error.message;
  }

  // Handle standard error message (but skip generic messages)
  if (error.message && error.message !== 'Bad Request' && error.message !== 'Internal Server Error') {
    return Array.isArray(error.message) ? error.message.join(', ') : error.message;
  }

  // Fallback to status text or default message
  return error.statusText || fallbackMessage;
}
